import { SideBarMenuItem } from 'components/Sidebar/types';
import { ROLES } from 'utils/consts/roles';

export const sidebarItems: SideBarMenuItem[] = [
  {
    icon: 'eye-slash',
    title: 'Мониторинг применения ЛП',
    submenu: [
      {
        roles: ROLES.monitoringLp.pharm,
        link: '/#/own/pharm',
        title: 'Мои лекарственные препараты',
      },
      {
        roles: ROLES.monitoringLp.reports,
        link: '/#/monitoring/reports',
        title: 'Список отчетов',
      },
      {
        roles: ROLES.monitoringLp.sentReports,
        link: '/#/monitoring/sent-reports',
        title: 'Периодические отчеты',
      },
      {
        roles: ROLES.monitoringLp.requests,
        link: '/#/registration/requests',
        title: 'Заявки на регистрацию',
      },
      {
        roles: ROLES.monitoringLp.modifyListRequests,
        link: '/#/pharm/patentee/modify-list-requests',
        title: 'Заявки на добавление ЛП',
      },
    ],
  },
  {
    icon: 'truck',
    title: 'Поставщик ЛП',
    submenu: [
      {
        roles: ROLES.supplierLp.patentee,
        link: '/#/supplier/own/pharm',
        title: 'Поставляю ЛП',
      },
      {
        roles: ROLES.supplierLp.rshsn,
        link: '/#/supplier/pharm/patentee/modify-list-requests',
        title: 'Заявки на добавление ЛП',
      },
    ],
  },
  {
    icon: 'shield',
    title: 'Заключения GMP',
    submenu: [
      {
        roles: ROLES.gmp.interact,
        link: '/react/gmp/addGmp',
        title: 'Добавить новое заключение',
      },
      {
        link: '/react/registry/gmp/registry',
        title: 'Государственный реестр заключений о соответствии (GMP)',
      },
    ],
  },
  {
    icon: 'unlock-alt',
    title: 'Разрешения на ввод в гражданский оборот',
    submenu: [
      {
        roles: ROLES.permits,
        link: '/react/pharmPermissions/addRequest',
        title: 'Добавить новую заявку',
      },
      {
        roles: ROLES.permits,
        link: '/react/registry/pharmPermissions/requests',
        title: 'Список заявок',
      },
      {
        link: '/react/registry/pharmPermissions/registry',
        title: 'Реестр разрешений на ввод в гражданский оборот',
      },
    ],
  },
  {
    icon: 'shield fa-flip-horizontal',
    title: 'Документы ДПО',
    submenu: [
      {
        roles: ROLES.dpo.create,
        link: '/react/dpo/addDpo',
        title: 'Добавить новый ДПО',
      },
      {
        link: '/react/registry/dpo/registry',
        title: 'Реестр ДПО',
      },
    ],
  },
  {
    icon: 'align-justify',
    title: 'Партии/серии, введенные в гражданский оборот',
    submenu: [
      {
        roles: ROLES.consignments.add,
        link: '/react/registry/consignments/add',
        title: 'Добавить партию/серию',
      },
      {
        roles: ROLES.consignments.registry,
        link: '/react/registry/consignments/registry',
        title: 'Мониторинг данных',
      },
      {
        roles: ROLES.consignments.argus,
        link: '/#/consignments/argus',
        title: 'Данные (АРГУС) в части ввоза и перемещения ЛС',
      },
    ],
  },
  {
    icon: 'medkit',
    title: 'Лекарственные препараты',
    submenu: [
      {
        roles: ROLES.pharmCard.create,
        link: '/#/registry/pharm/create',
        title: 'Добавить новую заявку',
      },
      {
        link: '/#/registry/pharm/requests',
        title: 'Список заявок',
      },
      {
        link: '/#/registry/pharm/registry',
        title: 'Реестр',
      },
      {
        link: '/#/registry/pharm/inactive',
        title: 'Список отмененных, отказанных, приостановленных',
      },
      {
        roles: ROLES.fakes.edit,
        link: '/react/registry/fakes/registry',
        title: 'Список фальсификатов и контрафактов',
      },
    ],
  },
  {
    icon: 'flask',
    title: 'Фарм. субстанции',
    submenu: [
      {
        roles: ROLES.substanceCard.create,
        link: '/#/registry/substance/create',
        title: 'Добавить новую заявку',
      },
      {
        link: '/#/registry/substance/requests',
        title: 'Список заявок',
      },
      {
        link: '/#/registry/substance/registry',
        title: 'Реестр',
      },
      {
        link: '/#/registry/substance/inactive',
        title: 'Список отказанных, исключений',
      },
    ],
  },
  {
    icon: 'leaf',
    title: 'Кормовые добавки',
    submenu: [
      {
        roles: ROLES.feedAdditiveCard.create,
        link: '/react/feed/addRequest',
        title: 'Добавить новую заявку',
      },
      {
        link: '/react/registry/feed/requests',
        title: 'Список заявок',
      },
      {
        link: '/react/registry/feed/registry',
        title: 'Государственный реестр кормовых добавок',
      },
    ],
  },
  {
    icon: 'pagelines',
    title: 'Продукция, полученная из ГМО',
    submenu: [
      {
        roles: ROLES.gmProduct.create,
        link: '/react/gmProduct/addRequest',
        title: 'Добавить новую заявку',
      },
      {
        link: '/react/registry/gmProduct/requests',
        title: 'Список заявок',
      },
      {
        link: '/react/registry/gmProduct/registry',
        title: 'Список зарегистрированных',
      },
      {
        link: '/react/registry/gmProduct/inactive',
        title: 'Регистрация аннулирована',
      },
    ],
  },
  {
    icon: 'hourglass',
    title: 'ГМО',
    submenu: [
      {
        roles: ROLES.gmo.create,
        link: '/react/gmo/addRequest',
        title: 'Добавить новую заявку',
      },
      {
        link: '/react/registry/gmo/requests',
        title: 'Список заявок',
      },
      {
        link: '/react/registry/gmo/registry',
        title: 'Список зарегистрированных',
      },
      {
        link: '/react/registry/gmo/inactive',
        title: 'Регистрация аннулирована',
      },
    ],
  },
  {
    icon: 'list',
    title: 'Рецепты (требования)',
    submenu: [
      {
        roles: ROLES.prescription.create,
        link: '/react/prescription/addRecord',
        title: 'Добавить новый рецепт (требование)',
      },
      {
        roles: ROLES.prescription.view,
        link: '/react/registry/prescription/registry',
        title: 'Реестр рецептов (требований)',
      },
      {
        link: '/react/registry/prescription/search',
        title: 'Поиск и погашение рецептов (требований)',
      },
      {
        roles: ROLES.prescription.view,
        link: '/react/registry/prescription/paper',
        title: 'Реестр бумажных рецептов (требований)',
      },
    ],
  },
  {
    icon: 'book',
    title: 'Справочники',
    submenu: [
      {
        roles: ROLES.catalogs,
        link: '/#/catalogs/business-entities',
        title: 'Реестр хоз.субъектов',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/adverseReactionTypes',
        title: 'Виды нежелательных реакций',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/animalSpecies',
        title: 'Виды животных',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/drugAdministrationWays',
        title: 'Путь ведения ЛП',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/informationSource',
        title: 'Источники получения информации о реакции',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/manualChangesTypes',
        title: 'Тип изменения в инструкции по применению ЛП',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/symptoms',
        title: 'Симптомы',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/units',
        title: 'Единицы измерения дозировки',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/pharmGroups',
        title: 'Фарм группы',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/signingPersons',
        title: 'Подписывающие лица',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/feedTypes',
        title: 'Типы кормовых добавок',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/feedKinds',
        title: 'Виды кормовых добавок',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/activeSubstances',
        title: 'Действующие вещества',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/pharmRelease',
        title: 'Форма выпуска лекарственных препаратов',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/pharmPackage',
        title: 'Виды упаковки лекарственных препаратов',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/activityKinds',
        title: 'Виды деятельности поднадзорных объектов',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/gmoUseTypes',
        title: 'Виды целевого использования ГМО',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/gmoReserchTypes',
        title: 'Виды экспертиз (исследований) ГМО',
      },
      {
        roles: ROLES.catalogs,
        link: '/react/catalogs/measuringUnits',
        title: 'Единицы измерения, используемые для ведения данных',
      },
    ],
  },
  {
    icon: 'question-circle',
    title: 'Инструкции',
    submenu: [
      {
        roles: ROLES.instructions.PATENTEE,
        link: '/#/instructions/PATENTEE',
        title: 'Для ХС',
      },
      {
        roles: ROLES.instructions.ADMIN_BE,
        link: '/#/instructions/ADMIN_BE',
        title: 'Для администратора ХС',
      },
      {
        roles: ROLES.instructions.VETERINARIAN,
        link: '/#/instructions/VETERINARIAN',
        title: 'Для ветеринарных учреждений',
      },
      {
        roles: ROLES.instructions.APOTHECARY,
        link: '/#/instructions/APOTHECARY',
        title: 'Для распространителей лекарственных препаратов',
      },
      {
        roles: ROLES.instructions.CENTRAL_APPARAT,
        link: '/#/instructions/CENTRAL_APPARAT',
        title: 'Для ЦА',
      },
      {
        roles: ROLES.instructions.VGNKI,
        link: '/#/instructions/VGNKI',
        title: 'Для ВГНКИ',
      },
    ],
  },
  {
    icon: 'exclamation-triangle',
    title: 'Обращения о нежелательных реакциях',
    submenu: [
      {
        link: '/react/adversePetitions/addRecord',
        title: 'Добавить новое обращение',
      },
      {
        link: '/react/registry/adversePetitions/search',
        title: 'Поиск обращения по Регистрационному номеру',
      },
      {
        roles: ROLES.adversePetitions.view,
        link: '/react/registry/adversePetitions/registry',
        title: 'Список обращений',
      },
    ],
  },
  {
    icon: 'user-secret',
    title: 'Реестр инспекторов',
    submenu: [
      {
        roles: ROLES.inspectors.edit,
        link: '/react/inspectors/add',
        title: 'Добавить нового инспектора',
      },
      {
        roles: ROLES.inspectors.view,
        link: '/react/registry/inspectors/registry',
        title: 'Реестр инспекторов',
      },
    ],
  },
];
